import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import focusDropdownSearch from 'scaleflow/utils/focus-dropdown-search';
import nameSort from 'scaleflow/utils/nameSort';

// Global cache to track which initiatives have had their workstreams fetched
const fetchedInitiatives = new Set();

export default class DropdownsWorkstreamsComponent extends Component {
  @service store;

  @tracked textFilter = '';

  tippyInstance = null;

  get initiative() {
    return this.store.peekRecord('initiative', this.args.initiative);
  }

  get trigger() {
    return this.args?.trigger ?? '';
  }

  get placement() {
    return this.args.placement ?? 'top';
  }

  get interactive() {
    return this.args.interactive ?? false;
  }

  get ComponentName() {
    return this.args?.tippy ? 'Tippy' : 'empty-component';
  }

  @action
  handleWorkstreamClick(item) {
    this.args?.onSelect?.(item);
    this.tippyInstance.hide();
    return;
  }

  get workstreamsList() {
    const workstreams = this.store
      .peekAll('workstream')
      .filter((item) => item.get('initiative.id') === this.args.initiative);
    const filteredWorkstreams = !this.textFilter
      ? workstreams
      : workstreams.filter(
          (item) =>
            item.title.toLowerCase().indexOf(this.textFilter.toLowerCase()) >=
            0,
        );
    return filteredWorkstreams.sort((a, b) => nameSort(a.title, b.title));
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  loadWorkstreams() {
    if (this.args.initiative === undefined) return;

    // Check if we've already fetched workstreams for this initiative
    if (fetchedInitiatives.has(this.args.initiative)) {
      return;
    }

    // Mark this initiative as fetched
    fetchedInitiatives.add(this.args.initiative);

    this.store.query('workstream', {
      filter: {
        initiative: this.args.initiative,
      },
    });
  }

  @action
  onShown(instance) {
    focusDropdownSearch(instance);
  }

  @action
  onCreate(e) {
    this.tippyInstance = e;
  }

  @action
  handleClearSelection() {
    this.args?.handleClearSelection();
    this.tippyInstance.hide();
  }

  @action
  handleAddWorkstream() {
    this.tippyInstance?.hide();
    this.args?.onAddWorkstream?.();
  }
}
